<template>
  <div class="gxjy">
    <div class="header">
      <div class="zhuti">
        <div class="h1">连接供需，共创价值
        </div>
        <div class="h2">
          <p>企业轻松发布代加工需求或展示生产能力，精准匹配</p>
            <p> 合作伙伴，拓展业务机会，实现资源共享与合作共赢</p>
        </div>
      </div>
    </div>
    <div class="bg1">
      <div class="zhuti type flex">
        <div class="typelist flex-1" v-for="(li,index) in ul" :key="index">
          <div class="image"> <el-image :src="li.icon"></el-image></div>
          <div class="name">{{li.name}} </div>
          <div class="desc ellipsis2">{{li.content}} </div>
        </div>
      </div>
      <div class="zhuti flex">
        <div class="flex-1 tab dai1" @click="gotolist(0)">
          <div class="h1">供应商</div>
          <div>我有加工能力    想找订单</div>
        </div>
        <div class="flex-1 tab dai2" @click="gotolist(1)">
          <div class="h1">采购商</div>
          <div>我想给产品    找加工企业</div>
        </div>
      </div>
      <div class="zhuti search">
        <el-input  style="width: 750px" v-model="keyword" placeholder="请输入关键词搜索">
          <el-button slot="append" @click="gotolist" icon="el-icon-search"></el-button>
        </el-input>
        <el-button style="float: right" icon="el-icon-s-promotion" @click="fabu" round size="small" type="primary">免费发布</el-button>
      </div>
    </div>
    <div class="content zhuti">
      <div class="title">找代工 <span @click="golist()">查看更多 <i class="el-icon-arrow-right"></i></span></div>
      <div class="alllist">
        <div class="list" v-for="(li,index) in arr"  @click="goxq(li)" :key="index">
          <div class="img">
            <el-image :src="li.image"></el-image>
            <el-tag type="success" size="small" style="background:#61B932;color: #fff;border:none;position: absolute;right: 10px;top: 10px" v-if="li.isMe">由我发布</el-tag>
<!--            <el-button v-else-if="li.isEnlists"  style="position: absolute;right: 10px;bottom: 10px"  disabled type="primary" round size="small">已报名</el-button>-->
<!--            <el-button v-else  type="primary" style="position: absolute;right: 10px;bottom: 10px" @click.stop="zixun(li)" round size="small">报名</el-button>-->
          </div>
          <div class="listtitle text-overflow">
            <div class="gx gong" v-if="li.sdType==0">供</div>
            <div class="gx  xu" v-else>需</div>
            {{li.title}}
          </div>
          <div class="time">{{li.createTime}}</div>
        </div>
      </div>
    </div>
    <div class="bg1" style="text-align: center">
      <el-button type="primary"  @click="golist()" size="small" class="btn" round>更多代工需求<i class="el-icon-arrow-right"></i></el-button>
    </div>
    <el-dialog title="报名" width="600px" append-to-body :visible.sync="dialogTableVisible">
      <el-form ref="form" :model="shen" label-width="120px" :rules="rules">
        <el-form-item label="报名描述：" prop="content">
          <el-input rows="5"  style="width: 300px" type="textarea" v-model="shen.content"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input   style="width: 300px" v-model="shen.contacts"></el-input>
        </el-form-item>
        <el-form-item label="手机号"   prop="phone">
          <el-input  style="width: 300px"  v-model.number="shen.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="margin-top: 20px;margin-left: 8px" @click="submitForm()">提交报名</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/utils/config";

export default {
  name: "index",
  components:{
  },
  data(){
    return {
      ul:[],
      arr:[],
      keyword:'',
      datas:'',
      zxid:'',
      shen:{},
      dialogTableVisible:false,
      rules: {
        content: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },{ type: 'number', message: '手机号必须为数字值'}
        ]
      },
    }
  },
  created() {
    this.loadconfig()
    this.loadlist()
  },
  methods:{
    zixun(item){
      this.shen={}
      this.zxid=item.id
      this.dialogTableVisible=true
    },
    submitForm(){
      this.shen.cpId=this.zxid
      this.$api.demand.processingenlists(this.shen).then((res)=>{
        this.dialogTableVisible=false
        this.$message({
          type: "success",
          message: "提交成功!"
        });
      })
    },
    golist(){
      this.$router.push({
        path:'/daigonglist'
      })
    },
    gotolist(type){
      this.$router.push({
        path:'/daigonglist',
        query:{
          keyword:this.keyword,
          type:type
        }
      })
    },
    goxq(li){
      this.$router.push({
        path:'/daigongxq',
        query:{
          id:li.id
        }
      })
    },
    fabu(){
      window.open(config.adminhref+'#/demand/daigong','_blank')
    },
    loadconfig(){
      this.$api.demand.processingindex().then((res)=>{
        this.ul=res.data.categoryList
      })
    },
    loadlist(bol){
      const obj={

      }
      obj.current=1
      obj.size=20
      this.$api.demand.contractprocessinglist(obj).then((res)=>{
        this.arr=res.data.records
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-image{
  border-radius: 4px;
}
.gx{
  border-radius: 4px;
  color: #fff;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-weight: bolder;
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}
.gong{
  background: #1266F9;
}
.xu{
  background: #61B932;
}
.gxjy{
  background: #f5f5f5;
  .zhuti{
    width: 1200px;
    margin: 0 auto;
  }
  .bg1{
    background: #fff;
  }
  .type{
    overflow: hidden;
    padding: 40px 0;
  }
  .search{
    padding: 36px 0;
  }
  .tab{
    color: #fff;
    padding: 36px;
    border-radius: 4px;
    cursor: pointer;
    .h1{
      font-size: 20px;
      font-weight: bolder;
      margin-bottom: 10px;
    }

  }
  .dai1{
    background: url("../../assets/gxjy/dai1.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 20px;
  }
  .dai2{
    background: url("../../assets/gxjy/dai2.png") no-repeat;
    background-size: 100% 100%;
  }
  .btn{
    margin: 20px auto;
  }
  .content{
    padding: 20px 0;
    .title{
      font-size: 20px;
      span{
        float: right;
        font-size: 12px;
        color: #1266F9;
      }
      .el-icon-arrow-right{
        font-size: 14px;
      }
    }
    .alllist{
      overflow: hidden;
      padding: 25px 0;
      .list{
        float: left;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;
        .img{
          width: 280px;
          height: 280px;
          position: relative;
        }
        .listtitle{
          width: 270px;
          font-weight: bolder;
          margin: 18px 0;
        }
        .time{
          font-size: 12px;
          color: #A8ADB6;
        }
      }
    }
  }
  .typelist{
    margin-right: 24px;
    background: linear-gradient(180deg,#F7F7F7,#FFFFFF);
    padding: 18px;
    width: 90px;
    .image{
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }
    .name{
      text-align: center;
      font-weight: bolder;
      margin: 17px 0;
    }
    .desc{
      font-size: 12px;
      color: #62656B;
    }
  }
  .typelist:nth-last-child(1){
    margin-right: 0;
  }
  .header{
    height: 230px;
    background: url("../../assets/gxjy/daigong.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 90px;
    color: #fff;
    .h1{
      font-size: 42px;
      margin-top: 25px;
    }
    .h2{
      font-size: 20px;
      line-height: 30px;
      margin-top: 15px;
    }
  }
}
</style>